import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseButton } from './PurchaseButton';
export function EmotionalClosingSection() {
  return <section className="py-24 md:py-28 px-4 bg-primary text-cream relative text-center overflow-hidden" data-id="element-130">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-131">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-132"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-gold/15 rounded-full blur-3xl" data-id="element-133"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-soft/10 rounded-full blur-3xl" data-id="element-134"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-136">
          <span className="font-sans text-gold text-xs font-bold tracking-[0.3em] uppercase mb-6 inline-block px-4 py-1.5 border border-gold/40 rounded-full" data-id="element-137">
            ✦ Tu Renacimiento ✦
          </span>

          <div className="w-16 h-[2px] bg-gold mx-auto mt-6 mb-8" data-id="element-138"></div>

          <h2 className="font-serif italic text-3xl md:text-4xl lg:text-5xl mb-10 leading-[1.3] text-cream" data-id="element-139">
            "Tal vez él nunca vino a darte el cierre que necesitabas…{' '}
            <span className="not-italic font-bold text-gold" data-id="element-140">
              pero hoy tú decides
            </span>{' '}
            dejar de seguir esperando."
          </h2>

          <div className="font-sans text-base md:text-lg text-cream/85 mb-10 leading-relaxed space-y-4 max-w-2xl mx-auto" data-id="element-141">
            <p data-id="element-142">
              Mereces recuperar la energía que estás dejando en alguien que ya
              no te elige. Mereces volver a habitarte, con{' '}
              <span className="font-bold text-gold" data-id="element-143">
                dignidad, libertad y poder
              </span>
              .
            </p>
            <p data-id="element-144">
              Eres una mujer que sana, que se reconstruye, que{' '}
              <span className="italic" data-id="element-145">se elige primero</span>. Y ese acto, hoy,
              es revolucionario.
            </p>
            <p className="font-bold text-white text-xl md:text-2xl font-serif italic pt-2" data-id="element-146">
              La decisión de soltarlo a él y volver a ti empieza con un solo
              paso. Da ese paso hoy.
            </p>
          </div>

          <div className="flex justify-center" data-id="element-147">
            <PurchaseButton text="SÍ, QUIERO VOLVER A MÍ" variant="dark" data-id="element-148" />
          </div>
        </motion.div>
      </div>
    </section>;
}